/** @format */

import { RootState } from "../store/store";

export const selectContributionStatus = (
	state: RootState,
	unionId: string,
	memberId: string
) => state.contribution.contributionStatus[`${unionId}-${memberId}`];

// export const selectCurrentCycleOfCircle = (state: RootState) =>
//   state.contribution.contributionCycle;

export const selectCurrentCycleOfCircle = (state: RootState, unionId: string) =>
	state.contribution?.contributionCycleByCircle?.[unionId] ?? null;

export const selectCurrentCycleById = (state: RootState, unionId: string) =>
	state.contribution?.contributionCycleByIdResult?.[unionId] || null;

export const selectMembersContribution = (state: RootState) =>
	state.contribution.memberContributionStatus;

// Selector to get member contribution status for a specific unionId
export const selectMembersContributionByUnion = (
	state: RootState,
	unionId: string
) => state.contribution?.memberContributionStatusByUnion?.[unionId] || null;

export const selectMemberContribution = (state: RootState) =>
	state.contribution.contributionStatus;

export const selectLoadMemberContributionStatus = (state: RootState) =>
	state.contribution.isLoading;

export const selectCurrentContributionCycleById = (state: RootState) =>
	state.contribution.contributionCycle;

export const selectContributionChartData = (
	state: RootState,
	unionId: string
) => {
	if (!state.contribution?.chartData) return null;
	return state.contribution.chartData[unionId] || null;
};

export const selectRealTimeContributionUpdates = (
	state: RootState,
	unionId: string
) => {
	if (!state.contribution?.realTimeUpdates) return null;
	return state.contribution.realTimeUpdates[unionId] || null;
};

export const selectCombinedChartData = (state: RootState, unionId: string) => {
	// First check if contribution state exists
	if (!state.contribution) {
		return null;
	}

	// Ensure chartData exists, but realTimeUpdates is optional
	if (!state.contribution.chartData) {
		return null;
	}

	const chartData = state.contribution.chartData[unionId];
	const realTimeUpdates = state.contribution.realTimeUpdates?.[unionId];

	if (!chartData) return null;

	// Merge real-time updates with chart data if available
	if (realTimeUpdates) {
		return {
			...chartData,
			realTimeStats: realTimeUpdates.stats,
			newContribution: realTimeUpdates.newContribution,
			lastRealTimeUpdate: realTimeUpdates.timeStamp,
		};
	}

	// Return chart data even without real-time updates
	return chartData;
};
